import React, { FC, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FontAwesomeIcons } from "../../constants/fontAwesomeIcons";

import "./FilterComponent.scss";

interface FilterComponentProps {
    filterOptions: string[];
    selectedFilterOptions: string[];
    setSelectedFilterOptions: (prev: any) => any;
}

const FilterComponent: FC<FilterComponentProps> = ({
    filterOptions,
    selectedFilterOptions,
    setSelectedFilterOptions,
}) => {
    const [filtersIsOpen, setFiltersIsOpen] = useState(false);

    const handleFilterChange = (option: string) => {
        setSelectedFilterOptions((prev) =>
            prev.includes(option)
                ? prev.filter((item) => item !== option)
                : [...prev, option]
        );
    };

    return (
        <div className="d-flex align-items-center">
            <button
                className="text-button px-3 text-nowrap"
                onClick={() => setFiltersIsOpen(!filtersIsOpen)}
                style={{ height: "32px" }}
            >
                Filters&nbsp;
                {filtersIsOpen ? (
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.CHEVRONLEFT} />
                ) : (
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.CHEVRONRIGHT} />
                )}
            </button>
            <div
                className={`slider d-flex align-items-center ${filtersIsOpen ? "slide-in" : "slide-out"}`}
                style={{ height: "32px" }}
            >
                {filterOptions.map((option, index) => (
                    <div
                        className="px-2 d-flex align-items-center my-checkbox"
                        key={`${option}-${index}`}
                    >
                        <input
                            className="checkbox-secondary"
                            type="checkbox"
                            id={option}
                            name={option}
                            value={option}
                            checked={selectedFilterOptions.includes(option)}
                            onChange={() => handleFilterChange(option)}
                            style={{ verticalAlign: "middle", cursor: "pointer" }}
                        />
                        <label
                            className="d-flex align-items-center mb-0 ml-1 text-nowrap"
                            htmlFor={option}
                            style={{ verticalAlign: "middle", cursor: "pointer" }}
                        >
                            {option}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FilterComponent;
